module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b9c886ce0382819a2ae97120a2ba0a7a.png";